export default __webpack_public_path__ + "static/media/0253.83dd9bda.jpg";